var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLandSize(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 30,
    viewBox: "0 0 22 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0254 0L3.6582 8.63793H6.65589L1.2194 16.1897H5.63972L0 23.6897H22L16.4619 16.2414L20.7298 16.1897L15.2425 8.68966H18.291L11.0254 0Z",
    fill: "#CAD7DC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.19637 24.9827H12.8038C13.1594 24.9827 13.4135 25.2413 13.4135 25.6034V29.3792C13.4135 29.7413 13.1594 29.9999 12.8038 29.9999H9.19637C8.84071 29.9999 8.58667 29.7413 8.58667 29.3792V25.6034C8.58667 25.2413 8.84071 24.9827 9.19637 24.9827Z",
    fill: "#CAD7DC"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandSize);
export default __webpack_public_path__ + "static/media/land_size.bbdc5eac0ec2473bce995ff1281c632e.svg";
export { ForwardRef as ReactComponent };